export default __webpack_public_path__ + "static/media/mua-sam.c93c49dc.jpg";